import React from 'react';
import { Handle, Position } from '@xyflow/react';
import Icon from '../../../ui/Icon';

export default function ConditionNode({ data }) {
  return (
    <div
      style={{
        background: '#FFFFFF',
        border: '1px solid #DDE1E7',
        borderRadius: 10,
        padding: '10px 14px',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        minWidth: 180,
        maxWidth: 220,
        boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
        position: 'relative',
      }}
    >
      <Handle
        type="target"
        position={Position.Left}
        style={{ width: 8, height: 8, background: '#718096', border: '2px solid #fff' }}
      />
      <div
        style={{
          width: 36,
          height: 36,
          borderRadius: '50%',
          background: '#f97316',
          display: 'grid',
          placeItems: 'center',
          flexShrink: 0,
          boxShadow: '0 1px 4px rgba(249,115,22,0.35)',
        }}
      >
        <Icon name="filter" size={16} color="#fff" />
      </div>
      <div style={{ fontSize: 12, fontWeight: 600, color: '#1A202C', lineHeight: 1.3 }}>
        {data.label || 'Condition'}
      </div>
      {/* YES output */}
      <div style={{ position: 'absolute', right: -28, top: '22%', fontSize: 10, fontWeight: 700, color: '#3B5BDB' }}>YES</div>
      <Handle type="source" position={Position.Right} id="yes" style={{ width: 8, height: 8, background: '#22c55e', border: '2px solid #fff', top: '28%' }} />
      {/* NO output */}
      <div style={{ position: 'absolute', right: -24, top: '62%', fontSize: 10, fontWeight: 700, color: '#ef4444' }}>NO</div>
      <Handle type="source" position={Position.Right} id="no" style={{ width: 8, height: 8, background: '#ef4444', border: '2px solid #fff', top: '68%' }} />
    </div>
  );
}
